import { getLocalized } from "../../../data/menu";

function DrinksMenuRow({ item, lang, onOpen, showDescription = false }) {
  const name = getLocalized(item.name, lang);
  const description = getLocalized(item.description, lang);
  const priceNote = getLocalized(item.priceNote, lang);
  const hasDescription = showDescription && Boolean(description);

  return (
    <li
      className={
        hasDescription
          ? "drinks-menu-row drinks-menu-row--described"
          : "drinks-menu-row"
      }
    >
      <button
        type="button"
        className="drinks-menu-row-btn"
        onClick={() => onOpen?.(item)}
      >
        <span className="drinks-menu-row-top">
          <span className="drinks-menu-row-name">{name}</span>
          <span className="drinks-menu-row-leader" aria-hidden="true" />
          <span className="drinks-menu-row-price">
            {item.price}
            {priceNote ? (
              <span className="drinks-menu-row-price-note"> {priceNote}</span>
            ) : null}
          </span>
        </span>
        {hasDescription ? (
          <span className="drinks-menu-row-desc">{description}</span>
        ) : null}
      </button>
    </li>
  );
}

export default DrinksMenuRow;
